export var LANG_OPTION_EN = 'en';
export var LANG_OPTION_ET = 'et';
export var LANG_OPTION_RU = 'ru';
export var LANG_SERVICE_DEFAULT = LANG_OPTION_EN;
export var LANG_SERVICE_SET = 'LANG_SERVICE_SET';
